export default __webpack_public_path__ + "static/media/placeholder_store04-es-mobile.a1428bbb.png";